import MainMobileView from './mobile/Main.mobile.view';
import MainDesktopView from './desktop/Main.desktop.view';
import { useIsDesktopDevice } from '../../tools/hooks/useIsDesktopDevice.ts';
import { useIsMobileDevice } from '../../tools/hooks/useIsMobileDevice.ts';

export default function MainView() {
  const isDesktop = useIsDesktopDevice();
  const isMobile = useIsMobileDevice();

  return (
    <>
      {isMobile && <MainMobileView />}
      {isDesktop && <MainDesktopView />}
    </>
  );
}
